var _rect, _rect2, _rect3, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 70,
    height: 50,
    rx: 4,
    fill: "#4A90D9",
    stroke: "#2570C0",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 35,
    width: 80,
    height: 15,
    rx: 4,
    fill: "#5BA3F5",
    stroke: "#2570C0",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 35,
    width: 14,
    height: 60,
    fill: "#FFD700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 35 C35 35 25 25 35 18 C40 15 50 25 50 35 C50 25 60 15 65 18 C75 25 65 35 50 35",
    fill: "#FFD700"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 18,
    r: 5,
    fill: "#FF8C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardBox);
export default __webpack_public_path__ + "static/media/reward-box.e1851206e8326b0ae434048ed100f064.svg";
export { ForwardRef as ReactComponent };